<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import LinkAccountCard from "../LinkAccountCard/LinkAccountCard.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
import { onMount } from "svelte";
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: useNbaIdBehavior = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.useNbaIdBehavior) || false;
$: clientConfig = (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.clientConfig;
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: specificAppId = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.specificAppId) || null;
$: titleOverride = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.titleOverride) || null;
$: imageOverrideUrl = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.imageOverrideUrl) || null;
$: linkCompleteAvatarImageUrl = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.linkCompleteAvatarImageUrl) || null;
$: linkCompleteImageOverrideUrl = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.linkCompleteImageOverrideUrl) || null;
$: connected = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.find(l => (l === null || l === void 0 ? void 0 : l.Type) === 'TICKETMASTER_ARCHTICS' && (!specificAppId || specificAppId === (l === null || l === void 0 ? void 0 : l.AppId))) : null) || false;
$: endWorkflow = (_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.endWorkflow;
let profileStore;
$: profileStore = findSourceStore($sources, 'YinzCamSignonServerProfile');
$: profileSource = $sources.find((s) => { var _a; return ((_a = s.spec) === null || _a === void 0 ? void 0 : _a.class) === 'YinzCamSignonServerProfile'; });
$: entries = profileStore ? $profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.Entry : [];
let profileRefreshed = false;
$: if (profileSource && !profileRefreshed) {
    setTimeout(() => {
        profileSource.refresh();
    }, 0);
    profileRefreshed = true;
}
let data = {};
$: {
    entries === null || entries === void 0 ? void 0 : entries.map(item => {
        data[item.Key] = item.Value;
    });
}
$: ticketmaster_email = (data === null || data === void 0 ? void 0 : data.email) || ({})['email'] || "";
const onConnect = (autoLink) => {
    if (!connected) {
        if (useNbaIdBehavior) {
            resolveUrl(`Login`).func();
        }
        else {
            ycSSOThirdPartyAuth("TICKETMASTER_PRESENCE", clientConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                console.log("ycSSOThirdPartyAuth callback inside TM", method, clientResult);
                if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.accessToken)) {
                    console.warn(`ycSSOThirdPartyAuth callback for ${method}: no access token in client result`);
                    return;
                }
                let result;
                f7.preloader.show('white');
                try {
                    result = yield signonManager.linkWithTicketmasterAccount(clientResult.accessToken, true, specificAppId);
                }
                finally {
                    f7.preloader.hide();
                }
                if (result.success) {
                    if (endWorkflow) {
                        signonManager.fireWorkflowEndEvent();
                    }
                    else {
                        let href = `Connected?linkedImage=${encodeURIComponent(linkCompleteImageOverrideUrl || '/static/icons/icon-ticketmaster.png')}`;
                        if (linkCompleteAvatarImageUrl) {
                            href += `&avatarImage=${encodeURIComponent(linkCompleteAvatarImageUrl)}`;
                        }
                        resolveUrl(href).func();
                    }
                }
                else {
                    alert(((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UserMessage) === null || _b === void 0 ? void 0 : _b.Content) || 'An error occurred.');
                }
            }));
        }
    }
    else if (!autoLink) {
        // TODO: Unlink using NBA ID API?
        let url = `DisconnectAccounts?accountType=ticketmaster`;
        if (specificAppId) {
            url += `&specificAppId=${encodeURIComponent(specificAppId)}`;
        }
        const resolved = resolveUrl(url);
        resolved.func();
    }
};
onMount(() => {
    var _a;
    if ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.autoLink) {
        onConnect(true);
    }
});
</script>

<CardBase {element}>
    {#if !(element && element.data && element.data.autoLink)}
    <LinkAccountCard title={titleOverride || 'Ticketmaster'} image={imageOverrideUrl || '/static/icons/icon-ticketmaster.png'} onConnect={() => onConnect(false)} {connected} {sources} email = {ticketmaster_email}/>
    {/if}
</CardBase>
